import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./OurWork.css";
import API_BASE_URL from "../../config";

import luxpillow from "../../assets/work/LuxPillow.svg";
import glamora from "../../assets/work/mockup2.png";
import amora from "../../assets/work/amoraEstate.png";
import dental from "../../assets/work/DentalThumbnail.png";
import inspire from "../../assets/work/hero-image.png";

const OurWorkPage = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      fetch(`${API_BASE_URL}/work-projects`)
        .then((res) => res.json())
        .then((data) => {
          const formattedData = data.map((item) => ({
            ...item,
            subtitle: item.subtitle.replace(/\s*–\s*/g, " | "),
          }));

          // Define the exact arrangement
          const arrangement = [1, 30, 31, 33, 32];

          // Arrange projects according to IDs
          const arrangedProjects = arrangement
            .map((id) => formattedData.find((p) => p.id === id))
            .filter(Boolean);

          setProjects(arrangedProjects);
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error fetching projects:", err);
          setLoading(false);
        });
    }, 300);
  }, []);

  // Separate projects by groups for wrappers
  const pillowAndGlamora = projects.filter((p) => p.id === 1 || p.id === 30);
  const singleAmora = projects.filter((p) => p.id === 31);
  const inspireAndDental = projects.filter((p) => p.id === 33 || p.id === 32);
  console.log("pillow", pillowAndGlamora);
  return (
    <>
      {loading ? (
        <div
          className="custom-loader"
          style={{
            height: "65vh",
            width: "100vw",
            position: "relative",
            zIndex: 1,
          }}
        >
          <div className="dots-loader">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      ) : (
        <section className="ourwork-section">
          <h2 className="ourwork-heading">Our Work</h2>
          <p className="ourwork-subheading">
            Explore all the projects we've crafted.
          </p>

          <section className="just-timepass">
            {/* Pillow & Glamora */}
            {pillowAndGlamora.length > 0 && (
              <div className="pillowAndGlamora">
                {pillowAndGlamora.map((p) => (
                  <Link
                    key={p.id}
                    to={`/worksub/${p.slug}`}
                    // className="ourwork-card"
                  >
                    <div className={p.id === 1 ? "pillow" : "glamora"}>
                      <img
                        src={p?.poster_url}
                        alt={p.title}
                        className={
                          p.id === 1
                            ? "ourwork-image-lux  animate from-left"
                            : "ourwork-image-glamora  animate from-right"
                        }
                        onLoad={(e)=>{e.currentTarget.classList.add("show")}}
                      />
                      <h4 className="ourwork-title">{p.title}</h4>
                      <p className="ourwork-subtitle">{p.subtitle}</p>
                    </div>
                  </Link>
                ))}
              </div>
            )}

            {/* Single Amora */}
            {singleAmora.length > 0 &&
              singleAmora.map((p) => (
                <Link
                  to={`/worksub/${p.slug}`}
                  key={p.id}
                  // className="ourwork-card"
                >
                  <div className="amora">
                    <img
                      src={p.poster_url}
                      alt={p.title}
                      className="ourwork-image-amora animate from-bottom"
                      onLoad={(e) => e.currentTarget.classList.add("show")}
                    />
                    <h4 className="ourwork-title">{p.title}</h4>
                    <p className="ourwork-subtitle">{p.subtitle}</p>
                  </div>
                </Link>
              ))}

            {/* Inspire & Dental */}
            {inspireAndDental.length > 0 && (
              <div className="inspireAndDental">
                {inspireAndDental.map((p) => (
                  <Link
                    to={`/worksub/${p.slug}`}
                    key={p.id}
                    // className="ourwork-card"
                  >
                    <div className={p.id === 33 ? "amora" : "amora"}>
                      <img
                        src={p.poster_url}
                        alt={p.title}
                        className={
                          p.id === 33
                            ? "ourwork-image-amora animate from-left"
                            : "ourwork-image-dental  animate from-right"
                        }
                        onLoad={(e)=>{e.currentTarget.classList.add("show")}}
                      />
                      <h4 className="ourwork-title">{p.title}</h4>
                      <p className="ourwork-subtitle">{p.subtitle}</p>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </section>
        </section>
      )}
    </>
  );
};

export default OurWorkPage;
